import React, { useState } from 'react';
import apiService from '../services/api';
import './ApiTest.css';

const ApiTest = () => {
  const [testResults, setTestResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const addTestResult = (test, status, message, data = null) => {
    setTestResults(prev => [...prev, {
      id: Date.now(),
      test,
      status,
      message,
      data,
      timestamp: new Date().toLocaleString()
    }]);
  };

  const runAllTests = async () => {
    setLoading(true);
    setTestResults([]);

    // Test 1: Health Check
    try {
      addTestResult('Health Check', 'running', 'Testing API connection...');
      const healthResponse = await apiService.healthCheck();
      addTestResult('Health Check', 'success', 'API is responding', healthResponse);
    } catch (error) {
      addTestResult('Health Check', 'error', error.message);
    }

    // Test 2: Get Talents
    try {
      addTestResult('Get Talents', 'running', 'Fetching talents...');
      const talentsResponse = await apiService.getTalents();
      addTestResult('Get Talents', 'success', `Found ${talentsResponse.rows?.length || 0} talents`, talentsResponse);
    } catch (error) {
      addTestResult('Get Talents', 'error', error.message);
    }

    // Test 3: Get Broadcasts
    try {
      addTestResult('Get Broadcasts', 'running', 'Fetching broadcasts...');
      const broadcastsResponse = await apiService.getBroadcasts();
      addTestResult('Get Broadcasts', 'success', `Found ${Array.isArray(broadcastsResponse) ? broadcastsResponse.length : 0} broadcasts`, broadcastsResponse);
    } catch (error) {
      addTestResult('Get Broadcasts', 'error', error.message);
    }

    // Test 4: Get Profile (with a test ID)
    try {
      addTestResult('Get Profile', 'running', 'Testing profile endpoint...');
      const profileResponse = await apiService.getTalentProfile('test123');
      addTestResult('Get Profile', 'success', 'Profile endpoint responding', profileResponse);
    } catch (error) {
      addTestResult('Get Profile', 'error', error.message);
    }

    setLoading(false);
  };

  const clearResults = () => {
    setTestResults([]);
  };

  return (
    <div className="api-test-container">
      <div className="api-test-header">
        <h2>API Connection Test</h2>
        <div className="test-controls">
          <button 
            onClick={runAllTests} 
            disabled={loading}
            className="run-tests-btn"
          >
            {loading ? 'Running Tests...' : 'Run All Tests'}
          </button>
          <button 
            onClick={clearResults}
            className="clear-results-btn"
          >
            Clear Results
          </button>
        </div>
      </div>

      <div className="test-results">
        {testResults.length === 0 ? (
          <div className="no-results">
            Click "Run All Tests" to test your API connection
          </div>
        ) : (
          testResults.map((result) => (
            <div key={result.id} className={`test-result ${result.status}`}>
              <div className="test-header">
                <span className="test-name">{result.test}</span>
                <span className="test-status">{result.status}</span>
                <span className="test-time">{result.timestamp}</span>
              </div>
              <div className="test-message">{result.message}</div>
              {result.data && (
                <details className="test-data">
                  <summary>View Response Data</summary>
                  <pre>{JSON.stringify(result.data, null, 2)}</pre>
                </details>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ApiTest;
